import { useEffect, useState } from "react";
import { removeDuplicatesFromArray } from "../libraries/ercLibrary";

export default function useVariantSelection(
  loading,
  error,
  product,
  choosenVariants
) {
  const [singleSku, setSingleSku] = useState("");
  const [fullVariantsArray, setFullVariantsArray] = useState("");

  // CREATE AN ARRAY WITH PRODUCT SKUS
  useEffect(() => {
    if (!loading && !error && product) {
      let targets;
      let types;
      let sizes;
      let colors;

      // GET SKUS
      const skus = product.skus.map((sku) => sku);

      // If there is single sku defined for the product than it is easy
      if (skus.length === 1) {
        setSingleSku(skus[0].sku);
      } else {
        setSingleSku("");
      }

      // If there are multiple skus, find out the deepness of variant levels
      if (skus.length > 1) {
        // variantLevel 4 => Top level is target. If there are target choices, this will be the first to choose by the user
        const variantTargets = Array.from(
          new Set(skus.map((sku) => sku.target))
        ).sort((a, b) => {
          const numA = Number(a.split("-")[3]) || 0;
          const numB = Number(b.split("-")[3]) || 0;
          return numA - numB;
        });

        if (variantTargets.length === 1) {
          targets = null;
        } else if (variantTargets.length > 1) {
          targets = {
            // This is the first part of variant that includes the label info.(Cinsiyet-Erkek-2852264) => Cinsiyet Seçiniz
            label: variantTargets[0].split("-")[0] + " Seçiniz",
            variants: variantTargets,
            skus: product.skus
              .filter(
                (sku) =>
                  variantTargets.includes(sku.target) && sku.countInStock > 0
              )
              .filter((sku) => sku !== null)
              .map((sku) => sku),
            availableVariants: removeDuplicatesFromArray(
              product.skus
                .filter(
                  (sku) =>
                    variantTargets.includes(sku.target) && sku.countInStock > 0
                )
                .filter((sku) => sku !== null && sku.target !== "Pass")
                .map((sku) => sku.target)
                .sort((a, b) => {
                  const numA = Number(a.split("-")[3]) || 0;
                  const numB = Number(b.split("-")[3]) || 0;
                  return numA - numB;
                })
            ),
          };
          targets.availableVariants.unshift(targets.label);
        }

        //  variantLevel 3 => Third level is type. This will be the second to choose if target and type exist. If not, it will be null
        const variantTypes = Array.from(
          new Set(skus.map((sku) => sku.type))
        ).sort((a, b) => {
          const numA = Number(a.split("-")[3]) || 0;
          const numB = Number(b.split("-")[3]) || 0;
          return numA - numB;
        });

        if (variantTypes.length === 1) {
          types = null;
        } else if (variantTypes.length > 1) {
          types = {
            // This is the first part of variant that includes the label info.(Cinsiyet-Erkek-2852264) => Cinsiyet Seçiniz
            label: variantTypes[0].split("-")[0] + " Seçiniz",
            variants: variantTypes,
            skus: product.skus
              .filter(
                (sku) => variantTypes.includes(sku.type) && sku.countInStock > 0
              )
              .filter((sku) => sku !== null)
              .map((sku) => sku),
            availableVariants: removeDuplicatesFromArray(
              product.skus
                .filter((sku) =>
                  variantTargets.length > 1 && // THIS CONDITION PROVES THERE IS A TARGET SELECTION OVER THE TYPE SELECTION
                  // choosenVariants => 0-Cinsiyet-Erkek-2852264,1-Kumaş-Airfile-3120316,2-Beden-Standart-4754192 => 1-Kumaş-Airfile-3120316
                  choosenVariants.toString().includes(sku.target)
                    ? variantTypes.includes(sku.type) && sku.countInStock > 0
                    : variantTargets.length === 1 // THIS CONDITION PROVES TYPE SELECTION IS ON THE TOP AND SIZE OR/AND COLOR MAY BE BELOW
                    ? variantTypes.includes(sku.type) && sku.countInStock > 0
                    : choosenVariants.toString().includes(sku.target) &&
                      variantTypes.includes(sku.type) &&
                      sku.countInStock > 0
                )
                .filter((sku) => sku !== null && sku.type !== "Pass")
                .map((sku) => sku.type)
                .sort((a, b) => {
                  const numA = Number(a.split("-")[3]) || 0;
                  const numB = Number(b.split("-")[3]) || 0;
                  return numA - numB;
                })
            ),
          };
          types.availableVariants.unshift(types.label);
        }

        //  variantLevel 2 => Second level is size.
        const variantSizes = Array.from(
          new Set(skus.map((sku) => sku.size))
        ).sort((a, b) => {
          const numA = Number(a.split("-")[3]) || 0;
          const numB = Number(b.split("-")[3]) || 0;
          return numA - numB;
        });

        if (variantSizes.length === 1) {
          sizes = null;
        } else if (variantSizes.length > 1) {
          sizes = {
            // This is the first part of variant that includes the label info.(Cinsiyet-Erkek-2852264) => Cinsiyet Seçiniz
            label: variantSizes[0].split("-")[0] + " Seçiniz",
            variants: variantSizes,
            skus: product.skus
              .filter(
                (sku) => variantSizes.includes(sku.size) && sku.countInStock > 0
              )
              .filter((sku) => sku !== null)
              .map((sku) => sku),
            availableVariants: removeDuplicatesFromArray(
              product.skus
                .filter((sku) =>
                  variantTypes.length > 1 &&
                  variantTargets.length === 1 && // THIS CONDITION PROVES THERE IS ONLY TYPE SELECTION OVER THE SIZE SELECTION
                  // choosenVariants => 0-Cinsiyet-Erkek-2852264,1-Kumaş-Airfile-3120316,2-Beden-Standart-4754192 => 1-Kumaş-Airfile-3120316
                  choosenVariants.toString().includes(sku.type)
                    ? variantSizes.includes(sku.size) && sku.countInStock > 0
                    : variantTypes.length === 1 && // THIS CONDITION PROVES THERE IS ONLY TARGET SELECTION OVER SIZE SELECTION
                      variantTargets.length > 1 &&
                      choosenVariants.toString().includes(sku.target)
                    ? variantSizes.includes(sku.size) && sku.countInStock > 0
                    : variantTypes.length === 1 // THIS CONDITION PROVES SIZE SELECTION IS ON THE TOP AND THERE MAY BE OR NOT A COLOR SELECTION BELOW
                    ? variantSizes.includes(sku.size) && sku.countInStock > 0
                    : // When nothing matches the conditions, this one works and this proves that there is type and target selections over the top
                      choosenVariants.toString().includes(sku.target) &&
                      choosenVariants.toString().includes(sku.type) &&
                      variantSizes.includes(sku.size) &&
                      sku.countInStock > 0
                )
                .filter((sku) => sku !== null && sku.size !== "Pass")
                .map((sku) => sku.size)
                .sort((a, b) => {
                  const numA = Number(a.split("-")[3]) || 0;
                  const numB = Number(b.split("-")[3]) || 0;
                  return numA - numB;
                })
            ),
          };
          sizes.availableVariants.unshift(sizes.label);
        }

        //  variantLevel 1 => First level is color.
        const variantColors = Array.from(
          new Set(skus.map((sku) => sku.color))
        ).sort((a, b) => {
          const numA = Number(a.split("-")[3]) || 0;
          const numB = Number(b.split("-")[3]) || 0;
          return numA - numB;
        });

        if (variantColors.length === 1) {
          colors = null;
        } else if (variantColors.length > 1) {
          colors = {
            // This is the first part of variant that includes the label info.(Cinsiyet-Erkek-2852264) => Cinsiyet Seçiniz
            label: variantColors[0].split("-")[0] + " Seçiniz",
            variants: variantColors,
            skus: product.skus
              .filter(
                (sku) =>
                  variantColors.includes(sku.color) && sku.countInStock > 0
              )
              .filter((sku) => sku !== null)
              .map((sku) => sku),
            availableVariants: removeDuplicatesFromArray(
              product.skus
                .filter((sku) =>
                  variantTypes.length === 1 &&
                  variantTargets.length === 1 &&
                  variantSizes.length > 1 && // THIS CONDITION PROVES THERE IS ONLY SIZE SELECTION OVER THE COLOR SELECTION
                  // choosenVariants => 0-Cinsiyet-Erkek-2852264,1-Kumaş-Airfile-3120316,2-Beden-Standart-4754192 => 1-Kumaş-Airfile-3120316
                  choosenVariants.toString().includes(sku.size)
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : variantTypes.length === 1 && // THIS CONDITION PROVES THERE IS ONLY TARGET SELECTION OVER COLOR SELECTION
                      variantTargets.length > 1 &&
                      variantSizes.length === 1 &&
                      choosenVariants.toString().includes(sku.target)
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : variantTypes.length > 1 && // THIS CONDITION PROVES THERE IS ONLY TYPE SELECTION OVER COLOR SELECTION
                      variantTargets.length === 1 &&
                      variantSizes.length === 1 &&
                      choosenVariants.toString().includes(sku.type)
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : variantTypes.length > 1 && // THIS CONDITION PROVES THERE IS TYPE AND TARGET SELECTION OVER COLOR SELECTION
                      variantTargets.length > 1 &&
                      variantSizes.length === 1 &&
                      choosenVariants.toString().includes(sku.type) &&
                      choosenVariants.toString().includes(sku.target)
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : variantTypes.length > 1 && // THIS CONDITION PROVES THERE IS SIZE AND TYPE SELECTION OVER COLOR SELECTION
                      variantTargets.length === 1 &&
                      variantSizes.length > 1 &&
                      choosenVariants.toString().includes(sku.type) &&
                      choosenVariants.toString().includes(sku.size)
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : variantTypes.length === 1 && // THIS CONDITION PROVES THERE IS ONLY COLOR SELECTION
                      variantTargets.length === 1 &&
                      variantSizes.length === 1
                    ? variantColors.includes(sku.color) && sku.countInStock > 0
                    : // When nothing matches the conditions, this one works and this proves that there is type,size and target selections over the top
                      choosenVariants.toString().includes(sku.target) &&
                      choosenVariants.toString().includes(sku.type) &&
                      choosenVariants.toString().includes(sku.size) &&
                      variantColors.includes(sku.color) &&
                      sku.countInStock > 0
                )
                .filter((sku) => sku !== null && sku.color !== "Pass")
                .map((sku) => sku.color)
                .sort((a, b) => {
                  const numA = Number(a.split("-")[3]) || 0;
                  const numB = Number(b.split("-")[3]) || 0;
                  return numA - numB;
                })
            ),
          };
          colors.availableVariants.unshift(colors.label);
        }
      }

      // This array contains variants to choose. If length of this array is 2, this means there are 2 variants to choose.
      setFullVariantsArray(
        [targets, types, sizes, colors].filter((item) => item !== null)
      );
    }
  }, [loading, error, product, choosenVariants]);

  // RETURN VALUES COLLECTED
  return {
    fullVariantsArray,
    singleSku,
  };
}
